import React, {useContext, useRef, useEffect} from 'react'
import LandingPage2 from "./LandingPage2.jpg"
import {Images} from "./Components/images"
import {Link} from "react-router-dom"
import { VenueContext } from "./Context"
import LandingPage from './LandingPage'
import Footer from "./Components/Footer"
import { TweenMax, Power3 } from "gsap"

function Overview() {
    const {getSpecificVenues, setVenues, venues, setDma} = useContext(VenueContext);

    window.onload = function () {
        setVenues(venues);
    }
     let icon1 = useRef(null);
     let icon2 = useRef(null);
     let icon3 = useRef(null);

     useEffect(() => {
         TweenMax.staggerFrom([icon1, icon2, icon3], .8, { opacity: 0, y: 1000, ease: Power3.easeOut }, .2)
     }, [])

    return (
        <React.Fragment>
            <LandingPage />
            <div className="container-fluid overview-wrap" id="Explore">
                <div className="module-text">
                    <h1>Discover & Book Performance Spaces</h1>
                    <p>The largest & most trusted online community to rent fairgrounds, festival venues, and concert spaces.</p>
                </div>
                <div className="row">
                    <div className="module1" style={{ background: `url(${LandingPage2}) center`, backgroundSize: "cover" }}>
                        <h1>Perform like a star for a night</h1>
                        <p>Lights, Sound, and Security included</p>
                        <Link to="/venues"><p>Learn More     <i class="fas fa-arrow-circle-right"></i> </p></Link>
                    </div>
                </div>
                <div id="HowItWorks" className="info-row row text-center">

                    <h1 className="col-12">How it works</h1>
                    <p className="col-12">Discover thousands of hosts with unique venues, where you can perform, celebrate or gather</p>
                    <div className="col-4" ref={element => icon1 = element} >
                        <i class="fas fa-map-marker-alt map-marker-overview"></i>
                        <p className="icon-desc">Browse venues and stages</p>
                    </div>
                    <div className="col-4" ref={element => icon2 = element} >
                        <i class="fas fa-comments-dollar"></i>
                        <p className="icon-desc">Compare rates, and prices with local hosts </p>
                    </div>
                    <div className="col-4" ref={element => icon3 = element}>
                        <i class="fas fa-check-circle"></i>
                        <p className="icon-desc">Book your venue in just a few clicks</p>
                    </div>
                </div>
                <div className="module-text">
                    <h1>Explore Venues</h1>
                    <p>Find local venues near you or  explore new ones around the world</p>
                </div>
                <div id="Venues" className="location-row row text-center my-5">
                    <Link to="/venues" className="col-lg-3 col-xs-12 mb-5 location-module" style={{ background: `url(${Images[1]}) center`, backgroundSize: "cover" }} onClick={() => { getSpecificVenues(324); setDma(324) }}>
                        <h1 className="city-name">Los Angeles</h1>
                    </Link>
                    <Link to="/venues" className="col-lg-3 col-xs-12 mb-5 location-module" style={{ background: `url(${Images[0]}) center`, backgroundSize: "cover" }} onClick={() => { getSpecificVenues(382); setDma(382) }}>
                        <h1 className="city-name">San Francisco</h1>
                    </Link>
                    <Link to="/venues" className="col-lg-3 col-xs-12 mb-5 location-module" style={{ background: `url(${Images[2]}) center`, backgroundSize: "cover" }} onClick={() => { getSpecificVenues(374); setDma(374) }}>
                        <h1 className="city-name">Sacramento</h1>
                    </Link>
                </div>
            </div>
            <Footer />
        </React.Fragment>
    )
}
export default Overview
